import React from 'react'

export const EditorCloseIcon = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.3264 1.82429L12.9116 0.410156L7.30214 6.01653L1.69273 0.410156L0.277832 1.82429L5.88724 7.43066L0.277832 13.037L1.69273 14.4512L7.30214 8.8448L12.9116 14.4512L14.3264 13.037L8.71704 7.43066L14.3264 1.82429Z'
      fill='#5F5F5F'
    />
  </svg>
)
